import React, { useState, useRef, useCallback } from 'react';
import { Checkbox } from '@material-ui/core';
import useUser from '../hooks/useUser'
import useListInfinite from '../hooks/useListInfinite'
import ListSelectSelected from './ListSelectSelected'
import './ListSelectCss.css'




const ListSelect = (props) => {

    const user = useUser()
    const [filterOrg, setFilterOrg] = useState(props.filterorgid || user.role === 'org-admin');
    const [query, setQuery] = useState({ sort: { field: props.sources[0], order: 'ASC' }, filter: createFilter({}, props.filterorgid || user.role === 'org-admin') })
    const [pageNumber, setPageNumber] = useState(1)
    const [addSelected, setAddSelected] = useState(null)
    const {
        items,
        hasMore,
        loading
    } = useListInfinite(query, pageNumber, props.target)
    const alertchange = props.alertchange
    const observer = useRef()
    const lastItemElementRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            const exceedsPage = items.length * pageNumber >= 20 * pageNumber
            if (entries[0].isIntersecting && hasMore && exceedsPage) {
                setPageNumber(prevPageNumber => prevPageNumber + 1)
            }
        })
        if (node) observer.current.observe(node)
    }, [loading, hasMore])

    function handleSearch(e, filter) {
        let rFilter = createFilter(filter, filterOrg)
        rFilter[filter.source] = e.target.value
        setQuery({ sort: { field: props.sources[0], order: 'ASC' }, filter: rFilter })
        setPageNumber(1)
    }

    function createFilter(inputFilter, filterByOrg) {
        let rFilter = inputFilter
        if (filterByOrg && props.record && props.record.org_id) rFilter.OrganizationId = props.record.org_id
        else if (filterByOrg && props.org_id) rFilter.OrganizationId = props.org_id
        return rFilter
    }

    function reloadFilter(val) {
        let rFilter = createFilter({}, val)
        setQuery({ sort: { field: props.sources[0], order: 'ASC' }, filter: rFilter })
    }

    function createRow(item) {
        let fields = []
        for (let source of props.sources) {
            fields.push(<div class="table-row-section">{item[source]}</div>)
        }
        return fields
    }

    const headers = props.headers.map(header => <div class="table-row-section table-row-section-header">{header}</div>)
    const rows = items.map((item, index) => {
        if (items.length === index + 1) {
            return <div class="table-row" onClick={() => setAddSelected(item)} ref={lastItemElementRef} key={item.id}>{createRow(item)}</div>
        } else {
            return <div class="table-row" onClick={() => setAddSelected(item)}>{createRow(item)}</div>
        }
    })

    const filters = props.filters.map(filter => <input class="table-filter" type="text" name="name" placeholder={filter.placeholder} onChange={(e) => handleSearch(e, filter)} />)

    return (
        <div class="select-table">
            <div class="select-header">{props.label ? props.label : props.target}</div>
            {!props.overrideTable && <div>
                {user.role !== 'org-admin' && props.filterorgid && <div>
                    Filter by Organization <Checkbox
                        checked={filterOrg}
                        onClick={(e) => {
                            reloadFilter(!filterOrg)
                            setFilterOrg(!filterOrg)
                        }} />
                </div>}
                <div>{filters}</div>
            </div>}
            <ListSelectSelected {...props} alertchange={alertchange} lastselected={addSelected} />
            {!props.overrideTable && <div>
                <div class="table-row no-hover table">{headers}</div>
                <div class="table">{rows}</div>
            </div>}
        </div >)

}
export default ListSelect;